import store from '../../store'
import * as Sentry from '@sentry/react'
import { getCurrentUserIDSelector } from '../../modules/selectors/app'
import { checkInternet } from './connection'

export const captureErrorToSentry = async ({ message, status, method, otherProps, data, params, error, toast }) => {
  const userId = getCurrentUserIDSelector(store.getState())

  // skip network errors to avoid spam of errors
  const isNetworkError = error?.code === 'ERR_NETWORK'
  // skip aborted Requests(when X clicked in browser during loading) by user
  const isAbortedRequest = error?.message === 'Request aborted'
  // skip requests with 401 status when user auth is not set
  const isAuthError = status === 401
  // skip token expiration errors
  const isTokenExpired = error?.message === 'Your session has expired. Please log in again.'
  const skipErrorsTracking = isNetworkError || isTokenExpired || isAuthError || isAbortedRequest

  if (!skipErrorsTracking) {
    // throw all api errors
    const newError = new Error(`${message}, user - ${userId}`)
    newError.name = `Request failed - API: ${otherProps.url}, App - ${window.location.hostname}`
    Sentry.captureException(newError, {
      user: {
        id: userId
      },
      extra: {
        method,
        status,
        url: otherProps.url,
        otherProps,
        dataPayload: JSON.stringify(data, null, 2),
        paramsPayload: params,
        error: error,
        response: error.response,
        responseData: JSON.stringify(error.response?.data, null, 2),
        toast,
        ...(navigator?.onLine ? {} : { online: 'false' }),
        ...(error.code === 'ECONNABORTED' && { hasInternet: await checkInternet() })
      }
    })
  }
}
